import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "grade-circle-outline-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.90637 16.177C8.49216 16.177 8.15637 15.8412 8.15637 15.427V12.841C8.15637 12.3809 8.33754 11.9364 8.66488 11.6078L8.66901 11.6037L12.669 7.60367C13.3525 6.92015 14.4609 6.91918 15.1444 7.60435L16.7297 9.18967C17.4133 9.87319 17.4142 10.9816 16.729 11.665L12.7367 15.6573L12.7298 15.6643C12.4025 15.9916 11.9568 16.177 11.4924 16.177L8.90637 16.177ZM13.7297 8.66433C13.8282 8.56585 13.9858 8.56683 14.0823 8.66365L14.0888 8.67006L15.6691 10.2503C15.7676 10.3488 15.7665 10.5064 15.6697 10.603L11.669 14.6037L11.6656 14.6071C11.6192 14.6517 11.5564 14.677 11.4924 14.677H9.65637V12.841C9.65637 12.7737 9.68315 12.7106 9.72829 12.6657L9.73388 12.6601L13.7297 8.66433Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.2276 18.8943C23.0353 15.0867 23.0353 8.91332 19.2276 5.10571C15.4201 1.2981 9.2467 1.2981 5.43909 5.10571C1.63147 8.9133 1.63147 15.0867 5.43908 18.8943C9.24668 22.7019 15.42 22.7019 19.2276 18.8943ZM6.49974 6.16637C9.72157 2.94454 14.9452 2.94454 18.167 6.16637C21.3885 9.38823 21.3887 14.6119 18.167 17.8336C14.9452 21.0554 9.72155 21.0554 6.49974 17.8336C3.27792 14.6118 3.27792 9.38818 6.49974 6.16637Z"
    }, null, -1)
  ])))
}
export default { render: render }